import Entity from '../entity';
import FlightOrder from './flightOrder';

export default class FlightOrderGeneral extends Entity<string> {
  creditLimit: number;
  referrerId: any;
  emailMessageId: any;
  emailMessage: any;
  totalPrice: number;
  currency: any;
  currencyId: string;
  orderNo: string;
  customer: any;
  payments: any[];
  flightOrders: FlightOrder[];
  agency: any;
  creationTime: string;
  orderStatus: number;
  operationStatus: number;
  marker: string;
  operatorName: any;
  isConfirmed: boolean;
}
